import { StyleSheet, type ViewStyle } from 'react-native';

import { SPLASH_COLORS, SPLASH_LOGO_SIZE, SPLASH_STREAKS } from './AnimatedSplash.constants';

export const animatedSplashStyles = StyleSheet.create({
  fill: {
    ...StyleSheet.absoluteFillObject,
    zIndex: 9999,
    elevation: 9999,
  },
  surface: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: SPLASH_COLORS.BACKGROUND,
  },
  stage: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  logoZone: {
    width: SPLASH_LOGO_SIZE,
    height: SPLASH_LOGO_SIZE,
    alignItems: 'center',
    justifyContent: 'center',
  },
  logo: {
    width: SPLASH_LOGO_SIZE,
    height: SPLASH_LOGO_SIZE,
  },
  ring: {
    position: 'absolute',
    bottom: 2,
    width: SPLASH_LOGO_SIZE * 0.92,
    height: 38,
    borderRadius: 999,
    borderWidth: 3,
    borderColor: SPLASH_COLORS.RING,
  },
  streakField: {
    position: 'absolute',
    bottom: 16,
    width: 1,
    height: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  streak: {
    position: 'absolute',
    width: 3,
    height: 16,
    borderRadius: 2,
    backgroundColor: SPLASH_COLORS.STREAK,
  },
  wordmark: {
    marginTop: 26,
    color: SPLASH_COLORS.WORDMARK,
    fontSize: 34,
    fontWeight: '800',
    letterSpacing: -1.2,
  },
});

/**
 * Per-streak static transforms (rotate + push outward), keyed streak0..streakN.
 * Built from SPLASH_STREAKS so the fan stays data-driven yet lint-clean (no inline styles).
 */
const streakTransformEntries = SPLASH_STREAKS.reduce<Record<string, ViewStyle>>(
  (acc, streak, index) => {
    acc[`streak${index}`] = {
      transform: [{ rotate: streak.rotate }, { translateY: -streak.offset }],
    };
    return acc;
  },
  {}
);

export const streakTransformStyles = StyleSheet.create(streakTransformEntries);

